var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-product-box"},[_c('div',{staticClass:"app-logo"},[_c('img',{attrs:{"src":require("@/assets/images/logo_blue.png")}})])])
}]

export { render, staticRenderFns }